import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, Button, Alert, } from 'reactstrap'
import { Link, } from 'react-router-dom'
import has from 'mout/object/has'
import countAnsweredQuestions from '../../helpers/assessment/countAnsweredQuestions'
import createMarkup from '../../helpers/createMarkup'
import getResumeNumber from '../../helpers/assessment/getResumeNumber';


/*
  <AssessTestPreview
    userAssessment={this.props.userAssessment}
    routeParams={this.props.routeParams}
    search={this.props.search}
    setInTest={this.props.setInTest}
    openTest={this.props.openTest}
  />

*/

export default function AssessTestPreview(props) {
  let subtestId = null
  let subtestDisplayName = null
  let testDisplayName = null
  let headerText = ''
  let subtest = null
  let destructuredSubtest = null
  let timeRemainingDisplay = ''
  let questionsAnswered = ''
  let totalQuestions = ''
  let directions = createMarkup('')
  let timeLimit = null
  let min = 0

  if (props.userAssessment) {
    subtestId = props.routeParams.subTestSetId
    subtestDisplayName = props.userAssessment.assessmentSubtests[subtestId] ? props.userAssessment.assessmentSubtests[subtestId].displayName : ''
    testDisplayName = props.userAssessment.assessmentSet.name
    headerText = `${testDisplayName}: ${subtestDisplayName}`
    subtest = props.userAssessment.assessmentSubtests[subtestId]
    destructuredSubtest = props.userAssessment.destructuredSubtests[subtestId]
    timeLimit = subtest ? subtest.timeLimit : 0

    if (subtest && subtest.directions) {
      directions = createMarkup(subtest.directions)
    }

    let timeMilli
    if (destructuredSubtest && destructuredSubtest.timeRemaining) {
      timeMilli = destructuredSubtest.timeRemaining
    } else {
      timeMilli = timeLimit * 60 * 1000
    }
    min = Math.floor(timeMilli / 60000)
    let sec = Math.ceil((timeMilli % 60000) / 1000)
    if (sec < 10) {
      sec = `0${sec}`
    }
    timeRemainingDisplay = `${min}:${sec}`

    totalQuestions = destructuredSubtest ? destructuredSubtest.items.length : 0

    if (has(props, `userAssessment.answersByItem.${subtestId}`)) {
      questionsAnswered = countAnsweredQuestions(props.userAssessment.answersByItem[subtestId])
    }
    //    } else {
    //      questionsAnswered = '0'
    //    }    

  }

  const hasStarted = timeLimit && parseInt(timeLimit) !== parseInt(min)

  let resumeMessage = null
  if (hasStarted) {
    resumeMessage = <Alert color='info'>You started this test but have not completed it. Click below to resume.</Alert>
  }

  let resumeNumber = 1
  if (hasStarted && props.userAssessment && props.userAssessment.answersByItem && props.userAssessment.answersByItem[subtestId]) {
    resumeNumber = getResumeNumber(props.userAssessment.answersByItem[subtestId], destructuredSubtest)
  }



  return (
    <Card>

      <Row className='assessment-test-header rounded-top' noGutters>
        <Col xs='12'>
          <h4 className='test-title'>{headerText}</h4>
        </Col>
      </Row>


      <CardBody>
        <h4>Directions:</h4>
        <div dangerouslySetInnerHTML={directions}></div>
        <p>{hasStarted ? `Time Remaining: ${timeRemainingDisplay}` : null}</p>
        <p>{hasStarted ? `Questions Answered: ${questionsAnswered ? questionsAnswered : '0'} / ${totalQuestions}` : null}</p>
        {resumeMessage}
        <Link to={`?item=${resumeNumber}`} onClick={() => props.openTest()}><Button color="primary">{questionsAnswered ? 'Continue' : 'Begin'}</Button></Link>
      </CardBody>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTestPreview.js